import React from "react";

export interface IConfirmPopupProps {
    heading?: string;
    heading2?: string;
    subHeading?: string;
    buttonPrimary: boolean;
    buttonSecondary: boolean;
    imageSrc?: string;
    imgAlt?: string;
    buttonPrimaryValue?: string;
    buttonSecondaryValue?: string;
    OnclickBtnP?:() => void;
    OnclickBtnS?:() => void;
}
const ConfirmPopup: React.FC<IConfirmPopupProps> = (props) => {
    return (
      <div className="modal_deleteApp">
        <div className="modal_delete_content  delete_modal">
          <div className="apiConnectWrap_lessWidth deleteApiApp">
            <div className="apiConnect delete_apiConnect">
              {props.imageSrc && <img
                src={props.imageSrc}
                alt={ props.imgAlt ? props.imgAlt :""}
                className="connectImg"
              />}
              <h1>{props.heading ? props.heading : ""}</h1>
              <span className="font-18">{props.heading2 ? props.heading2 : ""}</span>
              <p>{props.subHeading ? props.subHeading : ""}</p>
              <div className="display-space-evenly">
                {props.buttonSecondary && (
                    <button
                    className="custom-btn border-btn mg-b30"
                    onClick={props.OnclickBtnS}
                    >
                    <span>{props.buttonSecondaryValue}</span>
                    </button>
                )}
                {props.buttonPrimary && (
                    <button
                    className="custom-btn block-btn mg-b30"
                    onClick={props.OnclickBtnP}
                    >
                    <span>{props.buttonPrimaryValue}</span>
                    </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default ConfirmPopup;
